/**
 * @file index.tsx
 *
 * @fileoverview Contains Resume Sorting filter util functions.
 */
import { IntlShape } from 'react-intl';
import { SortingFilterOption } from '~/jobiqo/components/JobSearch/components/SortingFilter/utils';

/**
 * Returns a list of available sorting filter options for resume search.
 *
 * If an `intl` object is provided, the option names will be localized
 * using `intl.formatMessage`. Otherwise, default English labels are used.
 *
 * @param intl - Optional `IntlShape` instance for localization. If null, default labels are returned.
 * @returns An array of sorting filter option objects.
 */
export function getResumeSortingFilterOptions(
  intl: IntlShape | null = null,
): SortingFilterOption[] {
  return [
    {
      name: intl
        ? intl.formatMessage({
            id: 'sorting_filter_relevancy',
            defaultMessage: 'Relevancy',
          })
        : 'Relevancy',
      code: 'relevancy',
      field: 'search_api_relevance',
      value: 'desc',
    },
    {
      name: intl
        ? intl.formatMessage({
            id: 'resume_sorting_filter_last_update',
            defaultMessage: 'Last update',
          })
        : 'Last update',
      code: 'last_update',
      field: 'changed',
      value: 'desc',
    },
  ];
}
